var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRegionGlobal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 481,
    height: 481,
    viewBox: "0 0 481 481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(.405)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240.227,
    r: 240,
    fill: "#7BB1FA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#487FED",
    d: "M240,480.227436 C372.54834,480.227436 480.000151,372.775776 480.000151,240.227436 C419.06347,240.075812 339.09513,240 240.09513,240 C239.761797,345.666667 239.730087,425.742479 240,480.227436 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EBCF4",
    d: "M240,0.226631008 C107.45166,0.226631008 0,107.679096 0,240.227436 C41.6303425,240.139438 121.495386,240.063625 239.59513,240 C239.891853,147.227702 240.02681,67.3032456 240,0.226631008 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#588EFA",
    d: "M480,0.226631008 C347.45166,0.226631008 240,107.679096 240,240.227436 C281.630342,240.139438 361.495386,240.063625 479.59513,240 C479.891853,147.227702 480.02681,67.3032456 480,0.226631008 Z",
    transform: "matrix(-1 0 0 1 720.003 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6399F4",
    d: "M239.59513,0 C289.59513,0 339.59513,120 339.59513,240 C339.59513,360 289.59513,480 239.59513,480 C189.59513,480 139.59513,360 139.59513,240 C139.59513,120 189.59513,0 239.59513,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78A7F5",
    d: "M239.59513,0 C289.59513,0 339.59513,120 339.59513,240 C263.09513,240 213.59513,240 139.59513,240 C139.59513,120 189.59513,0 239.59513,0 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegionGlobal);
export default __webpack_public_path__ + "static/media/ic-region-global.f11c2be76c381e891cf528d8c641cef3.svg";
export { ForwardRef as ReactComponent };